import React, { Fragment, useState, useEffect, useMemo } from 'react';
import { connect } from 'react-redux';
import { Modal } from 'react-bootstrap';
import { Link, useHistory } from 'react-router-dom';
import { notification } from 'antd';

import AddCoundelor from './addCounselor';
import { counselordetail, getPersonnelActivityListService, editcounselor } from '../../services/directorServices';
import { reInviteCounselorService } from '../../services/userServices';
import { QUESTION_TYPES } from '../../config/staffFormSchema';
import StaffApplicationReadOnly, { resolveSnapshotSections } from './staffApplication/StaffApplicationReadOnly';
import { ProgramLoader } from '../reuse/SVG';


const EditCounselor = (props) => {
    let history = useHistory();
    const [counselorDetails, setCounselorDetails] = useState({});
    const [cd, setCd] = useState({});
    const [editMode, setEditMode] = useState(false);
    const [loading, setLoading] = useState(true);
    const [inviteEmailModal, setInviteEmailModal] = useState(false);
    const [pAList, setPAList] = useState([]);
    const [activityList, setActivityList] = useState([]);
    const [permissions, setPermissions] = useState({});

    useEffect(() => {
        let counselorId = props.match.params.id;
        counselordetail(`/?counselorId=${counselorId}`).then((res) => {
            if (res.data.statusCode) {
                setCounselorDetails(res.data.responseData.result);
                setCd(res.data.responseData.result.counselorDetails);
                setActivityList(res.data.responseData.result.activityList);
                setPermissions(res.data.responseData.result.permissions || {});
                setLoading(false);
            } else {
                history.push("/counselors");
            }
        });


        getPersonnelActivityListService(`/?personnelid=${props.match.params.id}`).then(res => {
            if (res.data.statusCode) {
                setPAList(res.data.responseData.result || []);
            }
        })
    }, [])


    const handelEditmode = () => {
        setLoading(true);
        let counselorId = props.match.params.id;
        counselordetail(`/?counselorId=${counselorId}`).then((res) => {
            setLoading(false);
            if (res.data.statusCode) {
                setCounselorDetails(res.data.responseData.result);
                setCd(res.data.responseData.result.counselorDetails);
                setEditMode(false)
            } else {
                history.push("/counselors");
            }
        })
    }


    const reInviteNotification = () => {

        let params = {
            email: counselorDetails.email,
            campCode: props.campCode
        }
        setInviteEmailModal(false);

        reInviteCounselorService(params).then(res => {

        })
    }


    // The application itself renders through StaffApplicationReadOnly, shared with the counselor's
    // own /profile/information view so the two cannot drift. Only the legacy-signature fallback
    // below still needs the sections directly.
    const sections = useMemo(() => resolveSnapshotSections(counselorDetails), [counselorDetails]);

    const hasSignatureQuestion = sections.some(section => section.questions.some(question => question.type === QUESTION_TYPES.SIGNATURE));


    const handlePermissionsChange = (key, val) => {
        let temp = {...permissions, [key]: val === 1 ? 0 : 1}
        setPermissions(temp);
        let form_data = new FormData();
        form_data.append('counselorId', props.match.params.id);
        form_data.append('permissions', JSON.stringify(temp));

        editcounselor(form_data).then( res => {
            notification.open({
                description: 'Permissions Updated Successfully',
            });
        })
    }


    return (
        <div className="body_container bg_light">
            {loading ? <div className="page_loader"><ProgramLoader /></div> : ''}

            <div className="container mt-5 mb-5 edit-counselor">
                <div className="row">
                    {
                        !editMode ?
                            <div className="col-lg-4">
                                <div className="card">
                                    <div className="profile_upload">
                                        <img src={counselorDetails.profileImage ? counselorDetails.profileImage : require('../../assets/img/user.png')} />
                                    </div>
                                    <p className="text-center">{counselorDetails.name}</p>
                                    <div className="col-sm-12 text-center mt-10">

                                        <Link className="btn btn-primary"
                                            to={{
                                                pathname: '/inbox',
                                                user: { "_id": counselorDetails._id, "name": counselorDetails.name, "type": 1 },

                                            }} style={{ width: '130px' }}>Message</Link>

                                        <br />
                                        {counselorDetails.firstLogin === 2 ? <button className="btn btn-secondary btn-sm mt-3" onClick={() => setInviteEmailModal(true)}>Resend invite email</button> : ''}


                                    </div>
                                </div>

                                <div className="card">
                                    <p><b>Group Assignment: </b> --</p>
                                    <p><b>Group Name: </b> ----</p>
                                </div>



                                <div className="card">
                                    <h5 className="mb-4">Activity View List</h5>
                                    {
                                        activityList.map(item => (
                                            <Link to={`/activity/edit/${item._id}`} key={item._id} className="cm_activity_card">
                                                <p><b>Name</b> : {item.activityName}</p>
                                                <p><b>Equipment</b>: {item.equipment}</p>
                                                <p><b>Cost</b>: {item.cost ? `$${item.cost}` : '0'}</p>
                                                <p><b>Time needed</b>: {item.timeNeeded}</p>
                                            </Link>
                                        ))
                                    }
                                </div>

                                <div className="card staff_permissions">
                                    <h5 className="mb-4">Permissions</h5>
                                    <p>
                                        <b>View Medical Information</b>
                                        <div className="cm_swich_wrap"><input onChange={() => handlePermissionsChange('viewMedical', permissions.viewMedical)} checked={permissions.viewMedical} type="checkbox" /><span /></div>
                                    </p>

                                    <p>
                                        <b>View Participant Information</b>
                                        <div className="cm_swich_wrap"><input onChange={() => handlePermissionsChange('viewCamper', permissions.viewCamper)} checked={permissions.viewCamper} type="checkbox" /><span /></div>
                                    </p>

                                    <p>
                                        <b>Ability to add user</b>
                                        <div className="cm_swich_wrap"><input onChange={() => handlePermissionsChange('addUser', permissions.addUser)} checked={permissions.addUser} type="checkbox" /><span /></div>
                                    </p>

                                    <p>
                                        <b>Ability to create booking</b>
                                        <div className="cm_swich_wrap"><input onChange={() => handlePermissionsChange('createBooking', permissions.createBooking)} checked={permissions.createBooking} type="checkbox" /><span /></div>
                                    </p>

                                    <p>
                                        <b>Ability to create program</b>
                                        <div className="cm_swich_wrap"><input onChange={() => handlePermissionsChange('createProgram', permissions.createProgram)} checked={permissions.createProgram} type="checkbox" /><span /></div>
                                    </p>

                                    <p>
                                        <b>Ability to edit program</b>
                                        <div className="cm_swich_wrap"><input onChange={() => handlePermissionsChange('editProgram', permissions.editProgram)} checked={permissions.editProgram} type="checkbox" /><span /></div>
                                    </p>

                                    <p>
                                        <b>Message Participant</b>
                                        <div className="cm_swich_wrap"><input onChange={() => handlePermissionsChange('messageCamper', permissions.messageCamper)} checked={permissions.messageCamper} type="checkbox" /><span /></div>
                                    </p>

                                    <p>
                                        <b>Post on Feeds</b>
                                        <div className="cm_swich_wrap"><input onChange={() => handlePermissionsChange('feedsByStaff', permissions.feedsByStaff)} checked={permissions.feedsByStaff} type="checkbox" /><span /></div>
                                    </p>
                                   
                                </div>
                            </div>
                            : ''
                    }
                    <div className={`col-lg-${editMode ? '12' : '8'}`}>
                        {
                            !editMode ?
                                <Fragment>
                                    <StaffApplicationReadOnly details={counselorDetails} />

                                    <div className="card mb-4">
                                        <h4 className="color_red">Record details</h4>
                                        <div className="all_counselorDetails">
                                            <p><b>Assign to folder: </b> {counselorDetails.folderName?.length ? counselorDetails.folderName.join(', ') : 'N/A'}</p>
                                            {/* Only when the form has no signature question to have shown it already. */}
                                            {hasSignatureQuestion ? null : (
                                                <p><b>Signature Image: </b> {cd?.signatureImg ? <img src={cd.signatureImg} alt="Signature" /> : 'N/A'}</p>
                                            )}
                                        </div>
                                    </div>

                                    {/* Outside the Record details card on purpose. Sitting inside it,
                                        centred under "Assign to folder", the button read as an action
                                        on that one card rather than on the whole application. */}
                                    <div className="text-end mb-4">
                                        <button onClick={() => setEditMode(true)} className="btn btn-primary" style={{ minWidth: '150px' }}>Edit application</button>
                                    </div>
                                </Fragment>
                                :
                                <div className="card mb-4">
                                    <AddCoundelor Details={counselorDetails} HideEditmode={handelEditmode} onSaved={handelEditmode} />
                                </div>
                        }




                    </div>



                </div>

            </div>


            <Modal
                dialogClassName="h_auto"
                show={inviteEmailModal}
                animation={false}
                centered
            >
                <Modal.Body>
                    <span className="modal_close" onClick={() => { setInviteEmailModal(false) }}><i className="icon-cross" /></span>
                    <div className="text-center p-4 pickup_modal_body">
                        <p>Are you sure you want to resend invite email?</p>
                    </div>
                    <div className="text-center mb-4">
                        <button onClick={() => setInviteEmailModal(false)} style={{ width: '120px' }} className="btn btn-light rounded-0">No</button>
                        <button onClick={reInviteNotification} style={{ width: '120px' }} className="btn btn-primary ms-3">Yes</button>
                    </div>
                </Modal.Body>
            </Modal>
        </div>

    )
}


const mapStateToProps = state => {
    let { userProfile } = state.user;
    let { campCode } = userProfile;

    return {
        campCode
    };
}

export default connect(mapStateToProps)(EditCounselor);